import axios from 'axios';
import { AppUrls } from './Globals';
import { Config } from './Config';

export const graphRequests = {}

graphRequests.GetGraphsData = () => {
  return axios.post(
    AppUrls.GetGraphsData,
    Config.SetParameters('', '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

//desencripta y devuelve objeto de la respuesta del API
let handleResponse = (response) => {
  let respObject = response.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    const error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}
